import _MedicalHistor from "./medicalHistoryDialog.vue";
import _HistoryTalkingMain from "./HistoryTalkingMain.vue";
import _MedicalHistoryMain from "./MedicalHistoryMain.vue";
import _HistoryTalking from "./HistoryTalking.vue";
import _MedicalHistory from "./MedicalHistory.vue";
import _MedicalCertificate from "./MedicalCertificate.vue";
import _ConfirmDrugDelivery from './ConfirmDrugDelivery.vue'
import _SendEditMedicine from './SendEditMedicine.vue'
import _MedicinePatient from './MedicinePatient.vue'
import _ConferenceKasemrad from './ConferenceKasemrad.vue'
import _ConferenceTelemed from './ConferenceTelemed.vue'
import _HistoryTakingKasemrad from './HistoryTakingKasemrad.vue'


export const MedicinePatient = _MedicinePatient;
export const MedicalHistor = _MedicalHistor;
export const HistoryTalkingMain = _HistoryTalkingMain;
export const MedicalHistoryMain = _MedicalHistoryMain;
export const HistoryTalking = _HistoryTalking;
export const MedicalHistory = _MedicalHistory;
export const MedicalCertificate = _MedicalCertificate;
export const SendEditMedicine = _SendEditMedicine
export const ConfirmDrugDelivery = _ConfirmDrugDelivery
export const ConferenceKasemrad = _ConferenceKasemrad
export const ConferenceTelemed = _ConferenceTelemed
export const HistoryTakingKasemrad = _HistoryTakingKasemrad







